<template>
  <span v-if="name" class="user-level" :class="['user-level--' + className]">{{ name }}</span>
</template>

<script>
export default {
  name: 'global-user-level',
  props: {
    userlevel: {
      type: String,
      default: '',
    },
  },
  computed: {
    name() {
      if (this.userlevel) {
        return (this.userlevel || '').toUpperCase();
      } else {
        return null;
      }
    },
    className() {
      const name = this.userlevel.toLowerCase();
      /*if (name === 'first clique') {
					return 'first-clique'
				}
				else if (name === 'fab clique') {
					return 'fab-clique'
				}
				else if (name === 'glam clique') {
					return 'glam-clique'
				}
				else if (name === 'royal clique') {
					return 'royal-clique'
				}
				else if (name === 'diamond clique') {
					return 'diamond-clique'
				}
				else {
					return 'soco-member'
				}*/
      // if (/first/.test(name)) {
      //   return 'first-clique';
      // } else if (/fab/.test(name)) {
      //   return 'fab-clique';
      // } else if (/glam/.test(name)) {
      //   return 'glam-clique';
      // } else if (/royal/.test(name)) {
      //   return 'royal-clique';
      // } else if (/diamond/.test(name)) {
      //   return 'diamond-clique';
      // } else {
      //   return 'soco-member';
      // }
      if (/rising/.test(name)) {
        return 'rising-star';
      } else if (/super/.test(name)) {
        return 'super-star';
      } else if (/diva/.test(name)) {
        return 'diva-star';
      } else {
        return 'soco-star';
      }
    },
  },
};
</script>

<style></style>
